<template>
  <fts-client-modal
    width="460px"
    :header="false"
    :footer="false"
    persistent
    class="fts-login-user-profile-modal"
    ref="ftsLoginUserProfileModal"
  >
    <template #body>
      <div class="comfort-form-design">
        <div class="login-user-profile-form-label">
          To personalize your account, please enter the name you would like to appear as your display name.
        </div>

        <fts-login-form-element
          type="display-name"
          v-model="formData.displayName"
          :validator="$v.formData && $v.formData.displayName"
        />

        <div class="fts-text-right" style="margin-top: 16px;">
          <fts-btn
            color="primary"
            @click.native.prevent="done"
          >
            <font-awesome-icon :icon="['fas', 'check']" /> Continue
          </fts-btn>
        </div>
      </div>
    </template>
  </fts-client-modal>
</template>

<script>
import Vue from 'vue';
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);
import { required } from 'vuelidate/lib/validators';

import FTSBtn from '../elements/FTSBtn';
import FTSClientModal from '../elements/FTSClientModal';
import FTSLoginFormElement from './FTSLoginFormElement';

export default {
  components: {
    'fts-btn': FTSBtn,
    'fts-client-modal': FTSClientModal,
    'fts-login-form-element': FTSLoginFormElement
  },
  data: () => ({
    resolve: null,
    formData: {}
  }),
  validations() {
    return { 
      formData: {
        displayName: { required }
      }
    }
  },
  methods: {
    async show() {
      return new Promise((resolve) => {
        this.resolve = resolve;
        this.$refs.ftsLoginUserProfileModal.show();
      });
    },
    done() {
      this.$v.formData.$touch();
      if (!this.$v.formData.$invalid) {
        this.resolve && this.resolve(this.formData);
        this.$v.$reset();
        this.$refs.ftsLoginUserProfileModal.close();
        Object.assign(this.$data, this.$options.data.apply(this));
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fts-login-user-profile-modal {
  .login-user-profile-form-label {
    margin-bottom: 1rem;;
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
</style>